module.exports = __webpack_public_path__ + "img/8.f8c4178c.jpg";